import { useEffect, useState } from 'react'
import { Row, Col, Button, Container } from 'react-bootstrap'
import { AiFillChrome } from 'react-icons/ai'
import { BsFillCalendar3EventFill } from 'react-icons/bs'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import API from "../../api/api";
import Actions from '../../redux/actions';

export default function Tutorial(props) {

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const usageType = useSelector(state => state.usageType)
    useEffect(() => {
    }, [])


    const _getStarted = async () => {
        const res = await API.getUser()
        const accounts = await API.getSubAccounts()
        const stats = await API.getStats()
        const filenames = await API.getFileNames()

        dispatch(Actions.setFileNames(filenames))
        dispatch(Actions.setStats(stats.stats))
        dispatch(Actions.setUser(res.user))

        dispatch(Actions.setAccounts(accounts))

        navigate('/', { replace: true })
    }

    return (
        <Container className='p-4 text-center'>
            <Row>
                <Col md={8} className={`bg-white shadow rounded my-auto mx-auto animate__animated animate__fadeIn text-center `}>
                    <div className='p-3'>
                        <h1>Watch Tutorial</h1>
                        <Row className='justify-content-center'>

                            <Col md={8}>
                                <p>Last Step! Watch the tutorial on how to use ScamWall below, and then click "Complete Signup"</p>

                                <div
                                    class="border rounded iframe-outer"
                                >
                                    <iframe
                                        src="https://player.vimeo.com/video/743708742?h=ca47d3d407&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0"
                                        allow="autoplay; fullscreen; picture-in-picture"
                                        allowfullscreen
                                        className='iframe-inner'
                                        title="ScamWall Tutorial"
                                    ></iframe>
                                </div>
                            </Col>
                        </Row>

                        <Button variant='primary mt-4' onClick={_getStarted}>Complete Signup</Button>

                    </div>
                </Col>
            </Row>
        </Container>
    )
}